import React, { Component } from "react";
import Common from "../../Common";
import Button from "../UI/Button";
import { AiOutlineFullscreen } from "react-icons/ai";
import { AiOutlineFullscreenExit } from "react-icons/ai";

export default class CountStatusBarComponent extends Common {
  constructor(props) {
    super(props);

    this.state = {
      count: 10,
      totalPage: 0,
      currentPage: 0,
    };
  }
  paginationSizeChange = (ev) => {
    this.props.api.gridOptionsWrapper.setProperty(
      "cacheBlockSize",
      Number(ev.target.value)
    );
    this.props.api.gridOptionsWrapper.setProperty(
      "maxblockincache",
      Number(ev.target.value)
    );
    this.props.aggFuncs(ev);
    this.props.api.paginationSetPageSize(Number(ev.target.value));
    // this.props.api.paginationSetPageSize(
    //   this.state.perPage.pagination_default_value
    // );
  };

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({
        count: this.props.api?.getDisplayedRowCount(),
        totalPage: this.props.api.paginationGetTotalPages(),
        currentPage: this.props.api.paginationGetCurrentPage() + 1,
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  onBtLast = () => {
    this.props.api.paginationGoToLastPage();
  };

  onBtFirst = () => {
    this.props.api.paginationGoToFirstPage();
  };
  onBtNext = () => {
    this.props.api.paginationGoToNextPage();
  };

  onBtPrevious = () => {
    this.props.api.paginationGoToPreviousPage();
  };

  render() {
    setTimeout(() => {
      this.setState({
        count: this.props.api?.getDisplayedRowCount(),
      });
    }, 100);

    return (
      <div className="ag-status-name-value">
        <div>
          <span className="component">Total Records &nbsp;</span>

          <span className="ag-status-name-value-value">{this.state.count}</span>
        </div>

        <div className="pagination_custom">
          <span>
            <Button onClick={this.onBtFirst} className="pagi">
              <span
                className="ag-icon ag-icon-first"
                unselectable="on"
                role="presentation"
              ></span>
            </Button>
          </span>

          <span>
            <Button onClick={this.onBtPrevious} className="pagi">
              {" "}
              <span
                className="ag-icon ag-icon-previous"
                unselectable="on"
                role="presentation"
              ></span>
            </Button>{" "}
          </span>
          <span className="lt_pagi">
            Page {this.state.currentPage} of {this.state.totalPage}
          </span>
          <span>
            <Button onClick={this.onBtNext} className="pagi">
              <span
                className="ag-icon ag-icon-next"
                unselectable="on"
                role="presentation"
              ></span>
            </Button>{" "}
          </span>
          <span>
            <Button onClick={this.onBtLast} className="pagi">
              <span
                className="ag-icon ag-icon-last"
                unselectable="on"
                role="presentation"
              ></span>
            </Button>
          </span>
        </div>
        <div className="page-size-status__bar">
          <span>Per Page</span> &nbsp;
          <select className="form-control" onChange={this.paginationSizeChange}>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          {this.props.showIconFullScreen && (
            <div className="fullscreen-layout">
              {this.props.isFullScreenView ? (
                <AiOutlineFullscreenExit
                  size={18}
                  onClick={this.props.closeFullScreen}
                  className="full-screen-view"
                />
              ) : (
                <AiOutlineFullscreen
                  size={18}
                  onClick={this.props.fullScreen}
                  className="full-screen-view"
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
